<template>
  <div id="app" class="bootstrap-iso container" v-if="packages">
    <div class="row d-flex">
      <h5 class="ml-3">CLIQUEZ SUR CES FORFAITS QUI POURRAIENT VOUS INTÉRESSER</h5>
    </div>
    <div class="row d-flex">

      <div class="col-lg-6 col-12 mb-3 p-0 cursor" v-for="exqc_package in packages" :key="exqc_package.id" v-on:click="gotopackage(exqc_package.id)">
        <img :src="process.env.VUE_APP_VED_IMAGES_URL + 'general_images/'+exqc_package.mainimage" style="width:100%">
        <span class="title">{{exqc_package.title}}</span>
        <span class="subtitle">{{exqc_package.subtitle}}</span>
        <div class="pricing">
          <span class="from">À partir de</span>
          <span class="beforeprice" v-if="exqc_package.pricebefore>exqc_package.pricenow">{{exqc_package.pricebefore}}$</span>
          <span class="realprice">{{exqc_package.pricenow}}$</span>
          <span class="occupation">(Occ. {{exqc_package.occupation}})</span>
        </div>
        <div class="ribbonwrapper" v-if="exqc_package.ribbontext">
          <div class="ribbon" v-html="exqc_package.ribbontext"></div>
        </div>
        <img class="explorequebeclogo" :src="process.env.VUE_APP_VED_GROUP_URL + 'pics/quebecexplore.png'" />
        <span class="bottom">Plusieurs dates de disponible!</span>
      </div>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import store from './store';

  const axios = require('axios').default;

  export default {
    name: 'ExploreQcWidget',
    data() {
      return {
        exploreqcid: null,
        packages: null,
        agencycontext: null,
      };
    },
    mounted() {
      this.exploreqcid = store.state.exploreqcid;
      const curagent = Vue.prototype.$cookies.get('agent');
      const hash = window.location.hash.replace('#', '');
      if (hash.length > 0 || curagent) {
        this.loadPackages();
      }
    },
    methods: {
      loadPackages() {
        const base = `${process.env.VUE_APP_VED_GROUP_URL}Api/index.php?packid=`;
        axios.get(`${base}${this.exploreqcid}`).then((response) => {
          this.packages = response.data.packages;
          this.setLoadPackageStats();
        });
      },
      setLoadPackageStats() {
        const url = `${process.env.VUE_APP_API_URL}load-packages`;
        const theref = window.location.href;
        const thepackagesids = [];
        this.packages.forEach((el) => {
          thepackagesids.push(el.id);
        });
        axios.post(url, { ref: theref, packagesids: thepackagesids });
      },
      gotopackage(packid) {
        // get agent or agency infos from cookie or hash
        let postdata = null;
        if (!this.agencycontext) {
          const hash = window.location.hash.replace('#', '');
          if (hash.length > 0) {
            postdata = { postid: hash };
          } else {
            const curagent = Vue.prototype.$cookies.get('agent');
            postdata = { agentid: curagent };
          }
          if (postdata.postid || postdata.agentid) {
            const self = this;
            axios.post(`${process.env.VUE_APP_VED_AGENT_URL}getagentwidget.php`, postdata).then((response) => {
              if (response.data.status) {
                self.agencycontext = response.data.infos;
              }
              self.redirectToPage(packid);
            });
          } else {
            this.redirectToPage(packid);
          }
        } else {
          this.redirectToPage(packid);
        }
      },
      redirectToPage(packid) {
        // track click
        const theref = window.location.href;
        const self = this;
        let thepackage = null;
        this.packages.forEach((el) => {
          if (el.id === packid) {
            thepackage = el;
          }
        });
        axios.post(`${process.env.VUE_APP_API_URL}set-click-package`, { ref: theref, packageid: packid, agencycontext: this.agencycontext }).then(() => {
          if (self.agencycontext) {
            axios.post(`${process.env.VUE_APP_API_URL}get-groups-details-domain-and-prefix`, { alias: self.agencycontext.alias }).then((response) => {
              if (response.data.status === 'OK') {
                const base = response.data.url;
                if (self.agencycontext.agentid) {
                  window.location.href = `${base}/${thepackage.permalink}#AG_${self.agencycontext.agentid}`;
                } else {
                  window.location.href = `${base}/${thepackage.permalink}`;
                }
              } else {
                const base = process.env.VUE_APP_VED_VED_GROUPS_URL;
                window.location.href = `${base}${thepackage.permalink}`;
              }
            });
          } else {
            const base = process.env.VUE_APP_VED_VED_GROUPS_URL;
            window.location.href = `${base}${thepackage.permalink}`;
          }
        });
      },
    },
  };
</script>

<style scoped>
  #app {
    width:100%;
  }

  .title{
    background-color: #275b8a;
    padding:10px 30px;
    position:absolute;
    top:0;
    left:0;
    z-index: 100;
    text-align: center;
    color:#fff;
  }
  .bottom{
    width: 100%;
    color:#fff;
    padding:10px 30px;
    background-color: #275b8a;
    display: block;
    font-size: 12px;
  }
  .pricing{
    background-color: #275b8a;
    padding:10px 10px;
    position:absolute;
    color:#fff;
    top:0;
    right:0;
    z-index: 100;
    text-align: right;
  }
  .pricing span{
    display: block;
  }
  .pricing span.from,.pricing span.occupation{
    font-size: 11px;
  }
  .pricing span.realprice{
    font-size: 24px;
    font-weight: bold;
  }
  .explorequebeclogo{
    position:absolute;
    bottom:20%;
    left: 2%;
    width: 12%;
  }
  .subtitle{
    position:absolute;
    background-color: #333;
    opacity: 0.8;
    color:#fff;
    font-size: 12px;
    font-weight: bold;
    padding:5px;
    top:23%;
    left:10px;
    z-index: 10;
  }
  .ribbon{
    background-color: #008000;
    color:#FFF;
    padding-top:10px;
    padding-bottom:10px;
    bottom:38px;
    display: block;
    padding-left:20px;
    padding-right:20px;
    right: 0;
    position:absolute;
  }
  .beforeprice{
    text-decoration: line-through;
    font-size: 14px;
  }
  .cursor{
    cursor: pointer;
  }
  h5{
    font-size: 1.4rem;
    font-weight: bold;
  }
  @media only screen and (min-width: 769px) {
    .cursor:nth-child(even) {
      padding-left: 0.25rem !important;
    }
    .cursor:nth-child(even) .title{
      left:0.25rem;
    }

    .cursor:nth-child(odd) {
      padding-right: 0.25rem !important;
    }
    .cursor:nth-child(odd) .pricing, .cursor:nth-child(odd) .ribbon{
      right:0.25rem;
    }
  }
  @media only screen and (max-width: 768px) {
    .title, .ribbon{
      font-size: 0.8rem;
    }
    .realprice{
      font-size: 1rem!important;
    }
    .pricing{
      padding-top:5px;
      padding-bottom:5px;
    }
    #app{
      position: relative;
      width: 94vw;
      margin-left: -50vw;
      margin-top: 100px;
      left: 50%;
    }
    h5{
      font-size: 1.3rem;
    }
  }
</style>
